import React from 'react';
export const BackArrow = () => (React.createElement("svg", { width: "21", height: "17", viewBox: "0 0 21 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { id: "Vector 31", d: "M21 8.5H1M1 8.5L8.30769 1M1 8.5L8.30769 16", stroke: "black" })));
